import { useApiClient } from "@myplant-io/utils/api";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { commonMessages } from "../commonMessages";
import { useAppState } from "../state/App";
import { Mode } from "../types";

export const defaultMode = "__default__";
export const noInnioMode = "__no_innio__";
export const innioTrainingsMode = "__innio_trainings__";
export const researcherMode = "__researcher__";
export const companyMode = "__company__";

export function useModes() {
  const client = useApiClient();
  return useQuery<Mode[]>("modes", () => client.fetch("/api/modes"));
}

export function useModeName() {
  const { formatMessage: t } = useIntl();
  const { data: modes } = useModes();
  return (id?: string) => {
    const m = modes?.find((m) => m._id === id)?.name || "";
    if (m === defaultMode) {
      return t(commonMessages.defaultMode);
    }
    if (m === noInnioMode) {
      return t(commonMessages.noInnioMode);
    }
    if (m === innioTrainingsMode) {
      return t(commonMessages.innioTrainingsMode);
    }
    if (m === researcherMode) {
      return t(commonMessages.researcherMode);
    }
    if (m === companyMode) {
      return t(commonMessages.companyMode);
    }
    return m;
  };
}

/**
 * Hook to ensure a valid mode is selected.
 * If no mode is selected or the selected mode doesn't exist,
 * it will select the first returned mode.
 */
export function useEnsureMode() {
  const {
    state: { modeId: mode },
    actions: { setModeId },
  } = useAppState();
  const { data: modes } = useModes();
  // select the first mode by default
  useEffect(() => {
    if (
      modes &&
      modes.length > 0 &&
      (!mode || (mode && modes.find((m) => m._id === mode) === undefined))
    ) {
      setModeId(modes[0]._id);
    }
  }, [mode, modes, setModeId]);
}
